// Cross-page link resolver. Any element carrying `data-page-link="<pageKey>"` gets its
// href resolved from the registry's localized slugs (golden rule #1: slugs live only in
// the registry). A `data-espace` companion attribute appends the `?espace` deep-link
// (the client login is an in-page toggle on the estimate page, not a separate route).

import { detectLang, routeHref } from '/shared/utils/core/url.js';

/**
 * Resolve every [data-page-link] href within a root against the active language.
 * @param {ParentNode} [root=document]
 */
export function initPageLinks(root = document) {
  const registry = window.PAGE_REGISTRY;
  const site = registry?.site;
  if (!site) return;

  const lang = detectLang(location.pathname, site);
  for (const el of root.querySelectorAll('[data-page-link]')) {
    const key = el.getAttribute('data-page-link');
    const page = registry.pages?.[key];
    if (!page) continue;
    // A RETIRED page is the old marketing site (owner-directed 2026-09-08): the real
    // site lives at site.publicSiteUrl now, so every link that pointed there — the
    // funnel logos, the pending page's way out — lands on it. Resolved HERE so no
    // consumer can keep a door open to a page the server only answers with a redirect.
    if (page.retired) {
      el.setAttribute('href', site.publicSiteUrl ?? routeHref(registry, key, lang));
      continue;
    }
    let href = routeHref(registry, key, lang);
    if (el.hasAttribute('data-espace')) href += '?espace';
    el.setAttribute('href', href);
  }
}
